import React, { useState } from "react";
import format from "date-fns/format";
import { Col, Form, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import Selectable from "../Form/Selectable";
import { useSelector } from "react-redux";
import { surveySelector } from "../../redux/surveySlice";
import DatePicker from "react-datepicker";
function Input({ field, showModal }) {
  const survey = useSelector(surveySelector);

  const handleChange = () => {
    var radios = document.getElementsByName(field.name);
    for (var radio of radios) {
      if (radio.checked) {
        field.handleChange(radio.value === "Yes");
      }
    }
  };
  const [startDate, setStartDate] = useState(new Date());
  return (
    <Col
      xxl={field.type === "textarea" ? "12" : "12"}
      sm={field.type === "textarea" ? "12" : "12"}
    >
      {field.type === "number" ||
      field.type === "use" ||
      field.type === "text" ||
      field.type === "textarea" ? (
        <div className="fieldset mb-4 mt-1">
          <Form.Group>
            <Form.Label>{field.title}:</Form.Label>
            {(field.type === "number" || field.type === "text") && (
              <Form.Control
                className=""
                type={field.type}
                value={survey[field.name] || ""}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={field.title}
              />
            )}
            {field.type === "use" && (
              <div className="form-control btn-control">
                <button
                  onClick={() => showModal()}
                  className="ps-0 w-100 text-start"
                >
                  <span>
                    <Icon icon="clarity:plus-line" />
                  </span>{" "}
                  {survey.currentUse ? survey.currentUse : "Select"}
                </button>
              </div>
            )}
            {field.type === "textarea" && (
              <Form.Control
                as="textarea"
                onChange={(e) => field.handleChange(e.target.value)}
                value={survey[field.name] || ""}
                placeholder="If applicable"
                style={{ height: "139px" }}
              />
            )}
          </Form.Group>
        </div>
      ) : (
        <Row className="align-items-center mb-4">
          <Col lg="6" md="6" sm="12" xs="6">
            <label>{field.title}</label>
          </Col>
          <Col lg="6" md="6" sm="12" xs="6">
            {field.type === "date" && (
              <div className="datePickerIcon float-lg-right">
                <button className="btn ctaIcon">
                  <Icon icon="cil:calendar" />{" "}
                </button>
                <DatePicker
                  className="form-control"
                  selected={
                    survey[field.name]
                      ? new Date(survey[field.name])
                      : new Date()
                  }
                  onChange={(date) => {
                    setStartDate(date);
                    field.handleChange(date.toISOString());
                  }}
                />
                {/* <span> {format(new Date(), "dd/MM/yyyy")}</span>*/}
              </div>
            )}
            {field.type === "select" && (
              <div className="selectNoBorder">
                <Selectable
                  options={field.options}
                  value={survey[field.name]}
                  onChange={(e) => field.handleChange(e)}
                />
              </div>
            )}
            {field.type === "boolean" && (
              <div className="optSelect">
                <div className="formCheck me-3">
                  <input
                    className="form-check-radio"
                    type="radio"
                    name={field.name}
                    value="Yes"
                    checked={survey[field.name]}
                    onChange={() => handleChange()}
                    id={field.id}
                  />
                  <label className="form-check-label" htmlFor={field.id}>
                    Yes
                  </label>
                </div>
                <div className="formCheck">
                  <input
                    className="form-check-radio"
                    type="radio"
                    name={field.name}
                    value="No"
                    checked={!survey[field.name]}
                    onChange={() => handleChange()}
                    id={field.id + "1"}
                  />
                  <label className="form-check-label" htmlFor={field.id + "1"}>
                    No
                  </label>
                </div>
              </div>
            )}
          </Col>
        </Row>
      )}
    </Col>
  );
}

export default Input;
